/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Rehearse_This_Meeting_BodyInputs */



/**
* | output |
* | --- |
* | "This conversation often goes differently than planned. Would you like to practise it once before you do it for real?" |
*
* @param {Nudge_Rehearse_This_Meeting_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_rehearse_this_meeting_body = /** @type {((inputs?: Nudge_Rehearse_This_Meeting_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Rehearse_This_Meeting_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit gesprek loopt vaak anders dan gepland. Wil je het één keer oefenen voor je het echt doet?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette conversation se passe souvent autrement que prévu. Voulez-vous la répéter une fois avant de la mener pour de vrai ?")
	return /** @type {LocalizedString} */ ("This conversation often goes differently than planned. Would you like to practise it once before you do it for real?")
});